import BadgeLogAdapter from 'garaje/adapters/badge-log';

export default class PersonAccessEventGroupAdapter extends BadgeLogAdapter {}
